/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable curly */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-trailing-spaces */
/* eslint-disable object-shorthand */
/* eslint-disable id-blacklist */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Stripe } from '@awesome-cordova-plugins/stripe/ngx';
import { loadStripe } from '@stripe/stripe-js';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  Platform,
  ToastController,
} from '@ionic/angular';

import { GlobalVariable } from '../global';
import { LoginModalPage } from '../login-modal/login-modal.page';
import { LocalStorageService } from '../services/core/local-storage.service';
import { UserApiService } from '../services/user-api.service';
import { TableNumpadPage } from '../table-numpad/table-numpad.page';
import { ThankyouPage } from '../thankyou/thankyou.page';
import { CONFIG } from '../services/app-config.service';
import { Router } from '@angular/router';
import { SavedCardComponent } from '../components/saved-card/saved-card.component';
interface PaymentData {
  creditcardno: String;
  expiryMonth: String;
  expiryYear: String;
  CVCcash_discount_confirmation: String;
  cardinfo: Boolean;
}
@Component({
  selector: 'app-payment-options',
  templateUrl: './payment-options.page.html',
  styleUrls: ['./payment-options.page.scss'],
})
export class PaymentOptionsPage implements OnInit {

  isCash: boolean;

  BirthdayCreditAvailed: any;
  enableTable = false;
  RewardCreditAvailed: any;
  business_array: any = new Array();
  deliver: any;
  StorePoint: any;
  order_date: any;
  instruction: string = '';
  Address: any;
  data: any;
  min: any;
  hours: any;
  future_hours: any;
  future_min: any;
  future_time: any;
  minutes: any;
  response: any;
  deliverFlag: boolean;
  estTime: any;
  storevalue: any;
  reward_amount: number = 0;
  storecreditExist: boolean = false;
  time: any;
  day: number;
  value: string;
  year: number;
  month: any;
  datenow: any;
  date: any;
  ProcessData: any;
  orderId: any;
  orderStatus: any;
  payapalresponse: any;
  cashpay: any = 0;
  ProcessForm: FormGroup;
  paypal: boolean = true;
  creditcard: boolean = false;
  pay_on_venue: boolean = false;
  pickup: boolean = false;
  Schedule_deliver: boolean = false;
  mytime: any;
  myDate: any;
  storeCredit: boolean;
  Deliver: boolean = true;
  deliver_now: boolean = true;
  Tip: number = 0;
  Notes: any;
  orderType: any;
  cash_on_delivery: any;
  gift_falg: boolean = false;
  gift_data: any;
  color: string = 'dark';
  payLaterColor: string = 'light';
  instructions: any = {
    Type: '',
    BusinessDiscount: 0,
    GainDiscount: 0,
    StoreCredit: 0,
    Tip: 0,
    Points: 0,
    Notes: '',
    giftcard: '',
    tax: 0,
    delivery_fee: 0,
  };
  month_array: any[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  amount: any = 0;
  tableStamp = [];
  cardinfo: any = {
    number: '',
    expMonth: '',
    expYear: '',
    cvc: '',
  };
  submitAttempt: boolean = false;
  payData: PaymentData;

  PaymentForm: FormGroup;
  calculated_tax = 0;
  cash_discount = 0;
  ccFee: number = 0;
  ccFee_added: boolean = true;
  paymentfrom = 'addNew';
  paymentMethods = [];
  subTotal: any;
  isSubmitted = false;
  loading;
  tableStampvalue: string = '';
  currentYear = new Date();
  yearArray: any = [];
  stationId: any;
  captchaPassed: boolean = false;
  stripeWeb: any;
  yearNew: any;
  private captchaResponse: string;
  constructor(
    private stripe: Stripe,
    public globals: GlobalVariable,
    public server: UserApiService,
    public fb: FormBuilder,
    public alertCtrl: AlertController,
    public navCtrl: NavController,
    private modalcontroller: ModalController,
    public localStorageService: LocalStorageService,
    private zone: NgZone,
    private alertController: AlertController
  ) {
    this.yearNew = this.currentYear.getFullYear();
    let years = this.currentYear.getFullYear() - 1;
    let i;
    for (i = 0; i < 10; i++) {
      years = years + 1;

      
      this.yearArray.push(years.toString());
    }
    this.payData = {} as PaymentData;
    if (!this.globals.guestLogin) {
      this.globals.udid = this.localStorageService.getUdId('UdId');
    }
    if (globals.kiosk_flag) {
    }

    this.calculated_tax = this.globals.paymentPageData.tax;

    this.subTotal = this.globals.paymentPageData.subtotal;
    this.ccFee = this.globals.paymentPageData.ccFee;
    this.cashpay = this.globals.paymentPageData.amount;
    this.amount = this.globals.paymentPageData.amount;
    this.storevalue = this.globals.paymentPageData.points_used;
    this.estTime = this.globals.estimated_time;
    this.orderType = this.globals.OrderType;
    // this.Address = localStorage.getItem('deliveryAddress');
    this.Address = globals.DeliveryAddress;
    console.log('address',this.Address);
    
    if (this.globals.card_enabled) {
      this.color = 'dark';
      this.payLaterColor = 'light';
      this.creditcard = true;
    } else {
      this.cash_on_delivery = true;
    }

    this.Tip = this.globals.paymentPageData.tip;
    this.ProcessForm = fb.group({
      Address: ['', Validators.compose([Validators.required])],
    });

    this.Notes = this.globals.paymentPageData.notes;
    this.date = new Date();
    this.datenow = this.date.getDate();
    this.month = this.date.getMonth() + 1;
    this.year = this.date.getFullYear();
    this.month = this.month.toString();
    this.day = this.date.getDay();
    this.datenow = this.datenow.toString();
    this.hours = this.date.getHours();
    this.min = this.date.getMinutes();
    if (this.month.length == 1) {
      this.month = '0' + this.month;
    }

    if (this.datenow.length == 1) {
      this.datenow = '0' + this.datenow;
    }

    this.value = this.year + '-' + this.month + '-' + this.datenow;
    this.value.toString();

    if (this.Schedule_deliver == false && this.pickup == true) {
      var date = new Date();
      var date1 = new Date(
        this.date.getTime() - this.date.getTimezoneOffset() * 60000
      ).toISOString();
      this.myDate = date1;
    }

    // this.amount = this.navParams.get('amount');
    this.amount = Number(this.amount);
    //   this.order_date = localStorage.getItem("scheduled_time");
    this.order_date = this.globals.scheduled_pickup_time;
    this.order_date = localStorage.getItem('scheduled_time');

    console.log('scheduled time is', this.order_date);
    this.getSavedCards();
    this.process();

    if (this.gift_falg) {
      this.payment_on_delivery();
    }
  }

  ngOnInit() {
    this.PaymentForm = this.fb.group({
      creditcardno: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(15),
          Validators.maxLength(16),
          Validators.pattern('[0-9]*'),
        ])
      ),
      expiryMonth: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      yearNew: new FormControl('', Validators.compose([Validators.required])),
      CVC: new FormControl('', Validators.compose([Validators.required])),
      cardinfo: new FormControl(''),
      saveCard: new FormControl(false),
    });

    let kiosk = JSON.parse(localStorage.getItem('kiosk'));
    console.log('kioskfromlocal', kiosk);
    if (kiosk != null && kiosk != undefined) {
      this.globals.kiosk_flag = kiosk;
    }
    
  }
  async openSavedCard(type: string) {
    const savedCardModel = await this.modalcontroller.create({
      component: SavedCardComponent,
      componentProps: { type: type },
      backdropDismiss: true,
      cssClass: 'SAVEDCARD',
      animated: true,
      swipeToClose: true,
      mode: 'ios',
    });

    savedCardModel.onDidDismiss().then((cardInfo: any) => {
      if (cardInfo !== null) {
        const data = cardInfo.data.data;
        this.cardinfo = {
          number: data.creditcardno,
          expMonth: data.expiryMonth,
          expYear: data.expiryYear,
          cvc: data.CVC,
        };
        this.updatePaymentFormValues(this.cardinfo);

      }
    });

    return await savedCardModel.present();
  }
  updatePaymentFormValues(cardData) {
    console.log('cardData', cardData.expYear);
    this.PaymentForm.patchValue({
      creditcardno: cardData.number,
      expiryMonth: cardData.expMonth,
      CVC: cardData.cvc,
      cardinfo: this.PaymentForm.value.cardinfo,
      saveCard: true,
      yearNew: cardData.expYear
    });
    
  }

  getSavedCards() {
    let tempArray = [];
    let response = localStorage.getItem('paymentmethods');
    tempArray = JSON.parse(response);
    console.log('from local storage', tempArray);
    if (tempArray != null) {
      this.paymentMethods = tempArray;
    }
  }
  get errorControl() {
    return this.PaymentForm.controls;
  }
  ionViewWillLeave() {
    this.globals.points_availed = 0;
  }
  process() {
    this.Instruction();
  }
  Instruction() {
    if (this.globals.catering_enabled) {
      this.instructions.number_of_persons =
        this.globals.cateringNumberOfPersons;
      this.instructions.order_type = 'catering';
    } else {
      this.instructions.order_type = 'regular';
    }
    if (this.globals.kiosk_flag) {
      this.instructions.table_stamp = this.tableStampvalue;
      this.instructions.kiosk = true;

      console.log('instrrr... ', this.instructions);
    }
    this.instructions.totalAmount = this.amount;

    this.instructions.tax = this.calculated_tax;
    if (this.orderType == 'delivery') {
      this.instructions.Type = 'Delivery';
    }

    if (this.orderType == 'pickup') {
      this.instructions.Type = 'Pickup';
    }

    if (this.globals.BusinessDiscountFlag == true) {
      this.instructions.BusinessDiscount = Number(
        this.globals.BusinessDiscount
      );
    }

    if (this.globals.GainDiscountFlag == true) {
      this.instructions.GainDiscount = Number(this.globals.GainDiscount);
    }
    if (this.Tip > 0) {
      this.instructions.Tip = Number(this.Tip);
    }

    if (this.Notes) {
      this.instructions.Notes = this.Notes;
    }

    if (Number(this.RewardCreditAvailed) > 0) {
      this.instructions.StoreCredit = Number(this.RewardCreditAvailed);
    }

    if (Number(this.BirthdayCreditAvailed) > 0) {
      this.instructions.StoreCredit = Number(this.BirthdayCreditAvailed);
    }

    // if (this.globals.points_availed > 0) {
    //   this.instructions.Points = Number(this.globals.points_availed);
    // }
    if (this.storevalue > 0) {
      this.instructions.Points = Number(this.storevalue);
    }
    //new added 22-6-2022 rameez
    if (this.globals.giftcardData && this.globals.giftcardData.amount > 0) {
      let array = [];
      array.push(this.globals.giftcardData);
      this.instructions.giftcard = array;
    }
    //new added end 22-6-2022 rameez

    if (this.globals.deliveryCharges > 0) {
      this.instructions.delivery_fee = Number(this.globals.deliveryCharges);
    }
    if (this.globals.couponAmount > 0) {
      this.instructions.coupon_id = this.globals.couponId;
      this.instructions.coupon_amount = this.globals.couponAmount;
      this.instructions.coupon_type = this.globals.couponType;
    }
    if (this.globals.subsidy > 0) {
      this.instructions.global_discount = this.globals.subsidy;
      this.instructions.discount_name = 'Member Subsidy';
    }

    // platform fee
    if (
      this.globals.platformFeeEnabled &&
      Number(this.globals.platformFeeAmount)
    ) {
      this.instructions.platformFeeEnabled = this.globals.platformFeeEnabled;
      this.instructions.platformFeeAmount = this.globals.platformFeeAmount;
      this.instructions.platformFeeLabel = this.globals.platformFeeLabel;
    }
  }

  async paymentThroughPayOnVenue() {
    //   let loading = await this.loadingCtrl.create({
    //       message: "Loading...",
    //   });
    //   await loading.present();
    this.globals.loader();

    let response = this.server.PaymentThroughPayOnVenue(
      this.instructions,
      this.cashpay
    );
    response.subscribe(
      async (data) => {
        this.data = data;
        this.globals.dismiss();
        if (this.data.success) {
          this.orderStatus = this.data.success;
          let alert = await this.alertCtrl.create({
            header: 'Congratulation',
            subHeader: 'Reservation order has been successfully placed.',
            buttons: ['Okay'],
          });
          await alert.present();
          this.navCtrl.navigateRoot('/tabs/tabs/home');
        } else {
          let alert = await this.alertCtrl.create({
            header: 'Error',
            subHeader: 'Please try again',
            buttons: ['OK'],
          });
          await alert.present();
        }
      },
      (error) => {
        this.globals.dismiss();
      }
    );
  }

  test() {
    console.log('testingAddress','address:'+ this.Address);
    
  }
  async payment_on_delivery() {
    if (this.captchaPassed || this.captchaResponse != undefined) {
      this.globals.loader();

      if (!this.globals.udid) {
        this.globals.udid = this.globals.kiosk_udid;
      }

      if (this.globals.GainDiscountFlag == true) {
        this.globals.GainDiscount = 0;
        this.setDiscount();
      }
      var status = 'cash';

      if (this.globals.OrderType == 'pickup') {
        this.Address = '';
      }
      if (this.globals.kiosk_flag) {
        this.instructions.table_stamp = this.tableStampvalue;
        this.instructions.kiosk = true;
      }

      if (this.order_date) {
        let date = new Date();
        let newdate = new Date(
          date.getTime() - date.getTimezoneOffset() * 60000
        ).toISOString();


        if (newdate > this.order_date) {
          this.order_date = newdate;
        }
      } else {
        let date = new Date();

        this.order_date = new Date(
          date.getTime() - date.getTimezoneOffset() * 60000
        ).toISOString();
      }

      this.captchaPassed = true;
      let response = this.server.PaymentOnDelivery(
        this.captchaResponse,
        this.subTotal,
        this.Address,
        this.instructions,
        Number(this.amount - this.ccFee).toFixed(2),
        this.order_date,
        '',
        status
      );

      console.log('delivery Data',
        this.subTotal,
        this.Address,
        status);
      

      let printerObj;

      if (this.globals.kiosk_flag) {
        let apiParam: any = this.makeApiParam(
          this.subTotal,
          this.Address,
          this.instructions,
          Number(this.amount - this.ccFee).toFixed(2),
          this.order_date,
          status,
          this.ccFee,
          ''
        );

        printerObj = this.getPrinterObj(
          apiParam,
          this.instructions,
          '',
          '',
          'cash'
        );
      }

      response.subscribe(
        async (data) => {
          this.data = data;
          this.globals.dismiss();

          if (this.data.success) {
            // localStorage.removeItem("scheduled_time");
            this.globals.scheduled_pickup_time = undefined;

            this.setArray();
            if (this.RewardCreditAvailed > 0) {
              this.RadeemStoreCredit(false);
            }

            if (this.BirthdayCreditAvailed > 0) {
              this.RadeemStoreCredit(true);
            }

            if (this.globals.points_availed > 0) {
              this.RedeemUserPoints();
            }

            if (
              this.globals.BusinessDiscount > 0 &&
              this.globals.availed_discount_count <
              this.globals.business_discount_count
            ) {
              this.userBusinessDiscountUpdate();
            }

            let printerIp = localStorage.getItem('printerId');
            if (this.globals.kiosk_flag && printerIp && printerIp != 'null') {
              let orderId = this.data?.orderId;

              printerObj.payment_info.order_id = orderId;

              let response3 = this.server.printInvoice(printerObj);
              response3.subscribe(
                async (data) => {
                  this.globals.dismiss();
                },
                (error) => {
                  this.globals.dismiss();
                }
              );
              this.signOut();
            }
            localStorage.removeItem('scheduled_time');
            console.log('timereset', true);
            this.thankyou();
          } else {
            this.captchaPassed = false;
            let alert_error = await this.alertCtrl.create({
              header: 'Error',
              subHeader: this.data.message,
              buttons: [
                {
                  text: 'Okay',
                  handler: (data) => { },
                },
              ],
            });

            await alert_error.present();
          }
        },
        (error) => {
          this.captchaPassed = false;
          this.globals.dismiss();
          console.log(error);
        }
      );
    }
    else {
      this.globals.presentToast('Verify Captcha', 'middle');
    }
  }

  setDiscount() {
    localStorage.setItem(
      'discount',
      JSON.stringify({ discountValue: this.globals.GainDiscount })
    );
  }

  setArray() {
    this.globals.itemsInCart.length = 0;
    this.globals.order_time = 'now';
    this.globals.myDate = undefined;
    //   localStorage.setItem("scheduled_time", undefined);
    this.globals.scheduled_pickup_time = undefined;

    localStorage.setItem(
      'cart',
      JSON.stringify({ array: this.globals.itemsInCart })
    );
  }
  async thankyou() {
    const modal = await this.modalcontroller.create({
      component: ThankyouPage,
      cssClass: 'thankYOU',
      componentProps: { date: this.order_date, orderid: this.data.orderId },
      backdropDismiss: false,
    });
    return modal.present();
  }

  RadeemStoreCredit(flag) {
    let response = this.server.LotteryRedeeem(this.StorePoint, flag);
    response.subscribe(
      (data) => {
        var response = data.json();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  RedeemUserPoints() {
    let res = this.server.RedeemUserPoints().subscribe(
      (data) => {
        if (data.status != 'true') {
          return false;
        } else {
          this.globals.points_availed = 0;
          return true;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
  userBusinessDiscountUpdate() {
    this.globals.availed_discount_count++;
    let response = this.server.userBusinessAvailedDiscount();
    response.subscribe(
      (data) => { },
      (error) => {
        console.log(error);
      }
    );
  }
  async login_kiosk() {
    let modal = await this.modalcontroller.create({
      component: LoginModalPage,
    });
    modal.present();
  }
  creditBox() {
    this.color = 'dark';
    this.payLaterColor = 'light';
    this.creditcard = true;
    this.cash_on_delivery = false;
    this.isCash = false;
  }
  deliveryBox() {
    this.payLaterColor = 'dark';
    this.color = 'light';
    this.creditcard = false;
    this.cash_on_delivery = true;
    this.isCash = true;
  }
  Savecreditcard(e) {
    if (e.detail.checked == true) {
      this.PaymentForm.get('saveCard').setValue(true);
    } else {
      this.PaymentForm.get('saveCard').setValue(false);
    }
    console.log(e, this.PaymentForm.value.cardinfo);
  }
  cancel() {
    this.navCtrl.navigateRoot('/new-cart');
  }
  cash_discount_confirmation(type, payment_data?) {
    if (type == 'cash') {
      this.payment_on_delivery();
    } else {
      this.payment_type(payment_data);
    }
  }
  payment_type(PaymentData) {
    if (this.captchaPassed || this.captchaResponse != undefined) {
      if (!this.globals.udid) {
        console.log('udid not found');
        this.globals.udid = this.globals.kiosk_udid;
      }
      if (this.globals.type == 'reservation') {
        this.pay_reservation(PaymentData);
      } else {
        this.pay(PaymentData);
      }
    } else {
      this.globals.presentToast('Verify Captcha', 'middle');
    }
  }

  async pay_reservation(PaymentData: any) {
    var a = btoa(PaymentData.creditcardno);
    if (!this.PaymentForm.valid) {
      this.submitAttempt = true;
    } else {
      if (PaymentData && this.PaymentForm.value.saveCard == true) {
        const filteredArray = this.paymentMethods.filter(
          (item) => item.creditcardno === this.PaymentForm.value.creditcardno
        );
        if (filteredArray.length == 0) {
          this.paymentMethods.push(this.PaymentForm.value);
          localStorage.setItem(
            'paymentmethods',
            JSON.stringify(this.paymentMethods)
          );
        }
      }

      this.cardinfo = {
        number: PaymentData.creditcardno,
        expMonth: PaymentData.expiryMonth,
        expYear: PaymentData.expiryYear,
        cvc: PaymentData.CVC,
      };
      this.globals.loader();

      if (this.globals.StripId == '') {
        this.globals.dismiss();

        let alert = await this.alertCtrl.create({
          message: 'Payments not available,please try again',
          buttons: ['OK'],
        });
        alert.present();
      } else {
        this.stripe.setPublishableKey(this.globals.StripId);
        this.stripe.createCardToken(this.cardinfo).then((Token) => {
          if (this.globals.GainDiscountFlag == true) {
            this.globals.GainDiscount = 0;
            this.setDiscount();
          }
          var status;
          if (this.globals.admin_stripe == 'true') {
            status = 'Gain';
          } else {
            status = 'Stripe';
          }
          if (this.globals.kiosk_flag) {
            this.instructions.table_stamp = this.tableStampvalue;
            this.instructions.kiosk = true;

            console.log('instrrr... ', this.instructions);
          }
          let response = this.server.PaymentThroughStripeReservation(
            this.instructions,
            this.amount,
            Token
          );
          response.subscribe(
            async (data) => {
              this.data = data;
              this.globals.dismiss();

              if (this.data.success) {
                let alert = await this.alertCtrl.create({
                  header: 'Congratulation',
                  subHeader: this.data.message,
                  buttons: ['OK'],
                });
                alert.present();

                this.setArray();
                if (this.RewardCreditAvailed > 0) {
                  this.RadeemStoreCredit(false);
                }
                if (this.BirthdayCreditAvailed > 0) {
                  this.RadeemStoreCredit(true);
                }
                if (this.globals.points_availed > 0) {
                  this.RedeemUserPoints();
                }

                this.navCtrl.navigateRoot('/tabs/tabs/home');
              } else {
                let alert_error = await this.alertCtrl.create({
                  header: 'Error',
                  subHeader: this.data.message,
                  buttons: ['OK'],
                });

                alert_error.present();
              }
            },
            (error) => { }
          );
        });
      }
    }
  }

  makeCardPayment() {
    if (this.captchaPassed || this.captchaResponse != undefined) {
      let stationId = JSON.parse(localStorage.getItem('kioskId'));

      if (stationId) {
        let apiParam: any = this.makeApiParam(
          this.subTotal,
          this.Address,
          this.instructions,
          this.amount,
          this.order_date,
          status,
          this.ccFee,
          stationId
        );

        let response = this.server.paymentCardInkiosk(apiParam);
        this.globals.loader();
        response.subscribe(
          async (data) => {
            if (
              data?.Result &&
              data?.Result.AP == '1' &&
              data?.Result.RT == 'APPROVED' &&
              data.TxnRef
            ) {
              let printerObj = this.getPrinterObj(
                apiParam,
                this.instructions,
                data.TxnRef,
                data.Rcpt,
                'credit'
              );
              let data2: any = apiParam.order_data;
              data2.order_number_payex = data.TxnRef;
              data2.instructions = this.instructions;
              let response2 = this.server.placeOrderAfterDejavo(
                apiParam.order_data
              );
              response2.subscribe(
                async (data) => {
                  this.globals.dismiss();
                  let response3 = this.server.printInvoice(printerObj);
                  response3.subscribe(
                    async (data) => {
                      console.log(data);
                    },
                    (error) => {
                      this.globals.dismiss();
                    }
                  );
                  this.data = data;
                  if (this.globals.kiosk_flag) {
                    this.signOut();
                  }
                  localStorage.removeItem('scheduled_time');
                  console.log('timereset', true);
                  this.thankyou();
                },
                (error) => {
                  this.globals.dismiss();
                }
              );
            } else {
              this.globals.dismiss();
              this.globals.presentToast(data?.display_message);
            }
          },
          (error) => {
            this.globals.dismiss();
            console.log(error);
            this.globals.presentToast('Something went wrong! Please try again.');
          }
        );
      } else {
        this.globals.presentToast(
          'Please Add Station Id From App Setting First!'
        );
      }
    } else {
      this.globals.presentToast('Verify Captcha', 'middle');

    }
  }

  getPrinterObj(
    apiParam: any,
    instructions: any,
    orderId: any,
    Rcpt: any,
    status: any
  ) {
    let clientName = localStorage.getItem('FirstName');
    // let cartItems = this.globals.itemsInCart;

    let cartItems = JSON.parse(localStorage.getItem('cart'));

    let printerObjData;
    let printerIp = localStorage.getItem('printerId');

    if (printerIp && printerIp !== 'null') {
      cartItems.forEach((orderItems) => {
        if (orderItems.menuExtrasSelected.length > 0) {
          orderItems.menuExtrasSelected.forEach((option) => {
            if (option.hasOwnProperty('options')) {
              option.optionNameSelected = option.options;
            }
          });
        }
      });

      printerObjData = {
        kitchen_print_format: 'format_1',
        table_name: '',
        extra_category_title_print: false,
        partialPrint: false,
        order_hold: '',
        customer_name: clientName ? clientName : '',
        staff_name: 'Danyaal Ameer',
        staff_id: '2',
        refund: false,
        udid: this.globals?.udid,
        giftcard: [],
        total: this.amount,
        scheduled_time: 'current',
        payment_type: '',
        type: status,
        given_value: 0,
        balance: '0.00',
        receipt: 'check',
        customer_phone: '',
        printer_meta: '',
        kitchen_format_regular: false,
        open_cashdrawer_credit: false,
        hold_staff_id: '',
        hold_staff_name: '',
        pos_station_name: '',
        rawText: Rcpt,
        fireLine: false,
        k_id: '158',
        vendor_name: '',
        checkPrintCount: 1,
        pos_receipt_number: '',
        hold_id: '',

        attributes: [
          {
            ip: printerIp,
            attributes: [
              {
                id: '193',
                attribute_text: 'DEFAULT',
                print_in: 'kitchen',
                priority: 0,
                printable: true,
                ip: printerIp,
                multiple_ips: [''],
              },
            ],
          },
        ],

        payment_info: {
          tax: instructions?.tax,
          address: '',
          token: '',
          order_date: '01/29/2024',
          order_time: '05:10 am',
          order_id: orderId,
          deliveryCharges: 0,
          delivery_fee: 0,
        },

        business_info: {
          name: this.globals?.businessName,
          address:
            this.globals?.business_address +
            '\n' +
            this.globals?.business_phone,
        },
        cc_amounts: {
          cash_amount: 0,
          credit_amount: 0,
          total: this.amount,
          message: '',
          cash_discount: 0,
        },
        order_info: cartItems,
        order_info_all_items: cartItems,
        instructions: apiParam.order_data.instructions,
      };
    } else {
      this.globals.presentToast('Please Add printer Id First ');
    }

    return printerObjData;
  }

  makeApiParam(
    subTotal: any,
    address: any,
    instructions: any,
    amount: any,
    order_date: any,
    status: any,
    ccFee: any,
    stationId: any
  ) {
    // let cartItems = this.globals.itemsInCart;
    let cartItems = JSON.parse(localStorage.getItem('cart'));

    cartItems.forEach((orderItems) => {
      if (orderItems.menuExtrasSelected.length > 0) {
        orderItems.menuExtrasSelected.forEach((option) => {
          if (option.hasOwnProperty('options')) {
            option.optionNameSelected = option.options;
          }
        });
      }
    });
    let orderdata: any = {
      Station: stationId,
      TxnRef: 'v7blp',
      Amount: amount,
      DeviceId: '123',
      PosName: 'POS 1',
      VendorId: CONFIG.business_id,
      DpsTxnRef: 'merchant',
      TenderType: 'CREDIT',
      authorization: false,

      // ---------------------------------------

      customer_name: '',
      printer_interface: 'lan',
      order_number: '',
      cash_amount: '',
      credit_amount: '',
      table_id: '',
      hold_id: '',
      username: '',
      udid: this.globals?.udid,
      headCount: '',

      // ----------------------------------------

      order_data: {
        udid: this.globals?.udid,
        timeTaken: '10 minutes',
        payment_info: {
          address: {},
          token: '',
          new_address: true,
          given_value: 0,
          balance: 0,
          deliveryCharges: 0,
          delivery_fee: instructions.delivery_fee,
        },
        order_info: cartItems,

        instructions: {
          clearTable: false,
          Type: instructions.Type,
          BusinessDiscount: instructions.BusinessDiscount,
          GainDiscount: instructions.GainDiscount,
          StoreCredit: instructions.StoreCredit,
          Tip: instructions.Tip,
          Points: instructions.Points,
          Notes: instructions.Notes,

          giftcard: instructions.giftcard,
          tax: instructions?.tax,
          order_type: instructions.order_type,
          platformFeeAmount: instructions.platformFeeAmount,
          platformFeeEnabled: instructions.platformFeeEnabled,
          platformFeeLable: instructions.platformFeeLabel,
          totalAmount: instructions.totalAmount,
          global_discount: 0,
          discount_name: '',
          calculatedDiscount: '0.00',
          calculatedTax: '0.00',
          cash_discount: this.ccFee,
          invoiceNumber: 0,
          giftcard_remaining_value: 0,
          date_of_event: '',
          station_name: '',
          refund_notes: '',
          delivery_fee: instructions.delivery_fee,
          qr: '',
          serviceCharge: '0.00',
          additionalTax: 0,
          deposit: 0,
          cart_instruction: '',
          subTotal: subTotal,
          orderTypeLabel: 'Pickup',
        },
        total: amount,
        scheduled_time: 'current',
        payment_type: 'dejavoo',
        pos: true,
        refund: false,
        subtotal: subTotal,
        platform: '',
        order_number_payex: '',
      },
    };

    console.log('helllllo', orderdata);

    return orderdata;
  }

  async pay(PaymentData: any) {
    // var a = btoa(this.payData.creditcardno);
    if (!this.PaymentForm.valid) {
      this.submitAttempt = true;
      this.globals.presentToast(
        ' Some values were not given or were incorrect, please fill them'
      );
    } else {
      if (PaymentData && this.PaymentForm.value.saveCard == true) {
        const filteredArray = this.paymentMethods.filter(
          (item) => item.creditcardno === this.PaymentForm.value.creditcardno
        );
        if (filteredArray.length == 0) {
          this.paymentMethods.push(this.PaymentForm.value);
          localStorage.setItem(
            'paymentmethods',
            JSON.stringify(this.paymentMethods)
          );
        }
      }

      this.cardinfo = {
        number: PaymentData.creditcardno,
        expMonth: PaymentData.expiryMonth,
        expYear: PaymentData.yearNew,
        cvc: PaymentData.CVC,
      };

      if (this.order_date) {
        let date = new Date();
        let newdate = new Date(
          date.getTime() - date.getTimezoneOffset() * 60000
        ).toISOString();

        console.log('orderdate is', this.order_date);
        if (newdate > this.order_date) {
          this.order_date = newdate;
          console.log('past order.......');
        } else {
          console.log('not past');
        }
      } else {
        console.log('no date');
        let date = new Date();

        this.order_date = new Date(
          date.getTime() - date.getTimezoneOffset() * 60000
        ).toISOString();
      }
      this.globals.loader();

      // if (this.globals.authorize_enabled) {
      if (this.globals.GainDiscountFlag == true) {
        this.globals.GainDiscount = 0;
        this.setDiscount();
      }
      var status;
      if (this.globals.authorize_enabled) {
        status = 'Authorize';
      } else {
        status = 'Stripe';
      }


      if (this.globals.OrderType == 'pickup') {
        this.Address = '';
      }
      if (this.globals.kiosk_flag) {
        this.instructions.table_stamp = this.tableStampvalue;
        this.instructions.kiosk = true;

        console.log('instrrr... ', this.instructions);
      }
      this.captchaPassed = true;
      let response = this.server.PaymentThroughStripe(
        this.captchaResponse,
        this.subTotal,
        this.Address,
        this.instructions,
        this.amount,
        this.order_date,
        '',
        status,
        this.ccFee,
        this.cardinfo
      );
      // response.subscribe(
      //   (data) => {
      //     this.data = data;
      //     this.globals.dismiss();
      //     if (this.data.success) {
      //       //   localStorage.removeItem("scheduled_time");
      //       this.globals.scheduled_pickup_time = undefined;

      //       this.setArray();
      //       if (this.RewardCreditAvailed > 0) {
      //         this.RadeemStoreCredit(false);
      //       }

      //       if (this.BirthdayCreditAvailed > 0) {
      //         this.RadeemStoreCredit(true);
      //       }

      //       if (this.globals.points_availed > 0) {
      //         this.RedeemUserPoints();
      //       }

      //       if (
      //         this.globals.BusinessDiscount > 0 &&
      //         this.globals.availed_discount_count <
      //         this.globals.business_discount_count
      //       ) {
      //         this.userBusinessDiscountUpdate();
      //       }
      //       if (this.globals.kiosk_flag) {
      //         this.signOut();
      //       }
      //       localStorage.removeItem('scheduled_time');
      //       console.log('timereset', true);

      //       this.thankyou();
      //     } else {
      //       this.captchaPassed = false;
      //       this.globals.presentToast(this.data.message);
      //     }
      //   },
      //   (error) => {
      //     this.captchaPassed = false;
      //   }
      // );




      response.subscribe({
        next: (data) => {
          this.data = data;
          this.globals.dismiss();
          if (this.data.success) {
            this.globals.scheduled_pickup_time = undefined;

            this.setArray();
            if (this.RewardCreditAvailed > 0) {
              this.RadeemStoreCredit(false);
            }

            if (this.BirthdayCreditAvailed > 0) {
              this.RadeemStoreCredit(true);
            }

            if (this.globals.points_availed > 0) {
              this.RedeemUserPoints();
            }

            if (
              this.globals.BusinessDiscount > 0 &&
              this.globals.availed_discount_count <
              this.globals.business_discount_count
            ) {
              this.userBusinessDiscountUpdate();
            }
            if (this.globals.kiosk_flag) {
              this.signOut();
            }
            localStorage.removeItem('scheduled_time');
            console.log('timereset', true);

            this.thankyou();
          } else {
            this.captchaPassed = false;
            this.globals.presentToast(this.data.message);
          }
        },
        error: (error) => {
          this.captchaPassed = false;
          console.error('Error placing order:', error.message);
          this.globals.dismiss();
          this.showErrorAlert();
        },
      });
      // } else {
      //   if (this.globals.StripId == '') {
      //     this.globals.dismiss();

      //     let alert = await this.alertCtrl.create({
      //       header: 'Oops',
      //       subHeader: 'Payments not available,please try again',
      //       buttons: ['OK'],
      //     });
      //     alert.present();
      //   } else {
      //     // if (this.platform.is('cordova')) {
      //     this.stripe.setPublishableKey(this.globals.StripId);
      //     this.stripe.createCardToken(this.cardinfo)
      //       .then((Token) => {
      //         console.log(Token);
      //         if (this.globals.GainDiscountFlag == true) {
      //           this.globals.GainDiscount = 0;
      //           this.setDiscount();
      //         }
      //         var status;
      //         status = 'Stripe';

      //         if (this.globals.OrderType == 'pickup') {
      //           this.Address = '';
      //         }
      //         if (this.globals.kiosk_flag) {
      //           this.instructions.table_stamp = this.tableStampvalue;
      //           this.instructions.kiosk = true;

      //           console.log('instrrr... ', this.instructions);
      //         }
      //         this.captchaPassed = true;
      //         let response = this.server.PaymentThroughStripe(
      //           this.captchaResponse,
      //           this.subTotal,
      //           this.Address,
      //           this.instructions,
      //           this.amount,
      //           this.order_date,
      //           Token,
      //           status,
      //           this.ccFee
      //         );
      //         response.subscribe(
      //           async (data) => {
      //             this.data = data;
      //             this.globals.dismiss();
      //             if (this.data.success) {
      //               //   localStorage.removeItem("scheduled_time");
      //               this.globals.scheduled_pickup_time = undefined;

      //               this.setArray();
      //               if (this.RewardCreditAvailed > 0) {
      //                 this.RadeemStoreCredit(false);
      //               }
      //               if (this.BirthdayCreditAvailed > 0) {
      //                 this.RadeemStoreCredit(true);
      //               }
      //               if (this.globals.points_availed > 0) {
      //                 this.RedeemUserPoints();
      //               }

      //               if (
      //                 this.globals.BusinessDiscount > 0 &&
      //                 this.globals.availed_discount_count <
      //                   this.globals.business_discount_count
      //               ) {
      //                 this.userBusinessDiscountUpdate();
      //               }
      //               if (this.globals.kiosk_flag) {
      //                 this.signOut();
      //               }
      //               this.thankyou();
      //             } else {
      //               this.captchaPassed = false;
      //               let alert_error = await this.alertCtrl.create({
      //                 header: 'Error',
      //                 subHeader: this.data.message,
      //                 buttons: [
      //                   {
      //                     text: 'Okay',
      //                     handler: (data) => {},
      //                   },
      //                 ],
      //               });
      //               alert_error.present();
      //             }
      //           },
      //           (error) => {
      //             this.captchaPassed = false;
      //             // loading.dismiss();
      //           }
      //         );
      //       })
      //       .catch(async (data) => {
      //         console.log(data);
      //         this.globals.dismiss();
      //         let alert = await this.alertCtrl.create({
      //           header: 'Oops',
      //           subHeader: 'Invalid Credentials, please try again',
      //           buttons: ['OK'],
      //         });

      //         alert.present();
      //       });
      //   // }
      //   // else{
      //   //   this.stripeWeb = await loadStripe(this.globals.StripId);
      //   //   const { paymentMethod, error } = await this.stripeWeb.createPaymentMethod({ type: 'card', card: this.cardinfo});

      //   //   if (paymentMethod) {
      //   //     console.log('stripe','Payment'); 
      //   //   } else {
      //   //     console.error('stripe:', error);
      //   //   }

      //   // }
      // }
      // }
    }
  }

  async showErrorAlert() {
    const alert = await this.alertController.create({
      header: 'Oops',
      // subHeader: 'Invalid Credentials, please try again',
      message: 'Failed to place the order. Please try again later.',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
        },
      ],
    });

    await alert.present();
  }

  async selectMethod(PaymentData) {
    console.log(PaymentData);
    this.cardinfo = {
      number: PaymentData.creditcardno,
      expMonth: PaymentData.expiryMonth,
      expYear: PaymentData.expiryYear,
      cvc: PaymentData.CVC,
    };

    this.globals.loader();

    if (this.globals.authorize_enabled) {
      console.log('Payment autherizeEnabled condition true');
      if (this.globals.GainDiscountFlag == true) {
        this.globals.GainDiscount = 0;
        this.setDiscount();
      }
      var status;
      status = 'Authorize';

      if (this.globals.OrderType == 'pickup') {
        this.Address = '';
      }
      if (this.globals.kiosk_flag) {
        this.instructions.table_stamp = this.tableStampvalue;
        this.instructions.kiosk = true;

        console.log('instrrr... ', this.instructions);
      }
      let response = this.server.PaymentThroughStripe(
        this.subTotal,
        this.Address,
        this.instructions,
        this.amount,
        this.order_date,
        '',
        status,
        this.ccFee,
        this.cardinfo
      );
      response.subscribe(
        (data) => {
          this.data = data;
          this.globals.dismiss();
          if (this.data.success) {
            localStorage.removeItem('scheduled_time');
            this.setArray();
            if (this.RewardCreditAvailed > 0) {
              this.RadeemStoreCredit(false);
            }

            if (this.BirthdayCreditAvailed > 0) {
              this.RadeemStoreCredit(true);
            }

            if (this.globals.points_availed > 0) {
              this.RedeemUserPoints();
            }

            if (
              this.globals.BusinessDiscount > 0 &&
              this.globals.availed_discount_count <
              this.globals.business_discount_count
            ) {
              this.userBusinessDiscountUpdate();
            }
            if (this.globals.kiosk_flag) {
              this.signOut();
            }
            localStorage.removeItem('scheduled_time');
            console.log('timereset', true);
            this.thankyou();
          } else {
            this.globals.presentToast(this.data.message);
          }
        },
        (error) => {
          this.globals.dismiss();
          this.globals.presentToast('Something wnt wrong. try again');
        }
      );
    } else {
      if (this.globals.StripId == '') {
        console.log('No stripe ID', this.globals.StripId);
        this.globals.dismiss();

        let alert = await this.alertCtrl.create({
          header: 'Oops',
          subHeader: 'Payments not available,please try again',
          buttons: ['OK'],
        });
        alert.present();
      } else {
        this.stripe.setPublishableKey(this.globals.StripId);
        this.stripe
          .createCardToken(this.cardinfo)
          .then((Token) => {
            if (this.globals.GainDiscountFlag == true) {
              this.globals.GainDiscount = 0;
              this.setDiscount();
            }
            var status;
            status = 'Stripe';

            if (this.globals.OrderType == 'pickup') {
              this.Address = '';
              if (this.globals.kiosk_flag) {
                this.instructions.table_stamp = this.tableStampvalue;
                this.instructions.kiosk = true;
                console.log('instrrr... ', this.instructions);
              }
            }
            this.captchaPassed = true;
            let response = this.server.PaymentThroughStripe(
              this.captchaResponse,
              this.subTotal,
              this.Address,
              this.instructions,
              this.amount,
              this.order_date,
              Token,
              status,
              this.ccFee
            );
            response.subscribe(
              async (data) => {
                this.data = data;
                this.globals.dismiss();
                if (this.data.success) {
                  this.setArray();
                  if (this.RewardCreditAvailed > 0) {
                    this.RadeemStoreCredit(false);
                  }
                  if (this.BirthdayCreditAvailed > 0) {
                    this.RadeemStoreCredit(true);
                  }
                  if (this.globals.points_availed > 0) {
                    this.RedeemUserPoints();
                  }

                  if (
                    this.globals.BusinessDiscount > 0 &&
                    this.globals.availed_discount_count <
                    this.globals.business_discount_count
                  ) {
                    this.userBusinessDiscountUpdate();
                  }
                  if (this.globals.kiosk_flag) {
                    this.signOut();
                  }
                  localStorage.removeItem('scheduled_time');
                  console.log('timereset', true);
                  this.thankyou();
                } else {
                  this.captchaPassed = false;
                  let alert_error = await this.alertCtrl.create({
                    header: 'Error',
                    subHeader: this.data.message,
                    buttons: [
                      {
                        text: 'Okay',
                        handler: (data) => { },
                      },
                    ],
                  });
                  alert_error.present();
                }
              },
              (error) => {
                this.captchaPassed = false;
                // loading.dismiss();
              }
            );
          })
          .catch(async (data) => {
            console.log('stripe failed', data);
            this.globals.dismiss();
            let alert = await this.alertCtrl.create({
              header: 'Oops',
              subHeader: 'Invalid Credentials, please try again',
              buttons: ['OK'],
            });

            alert.present();
          });
      }
    }
  }


  async tableModel() {
    const modal = await this.modalcontroller.create({
      component: TableNumpadPage,
      breakpoints: [0, 1],
      initialBreakpoint: 1,
      swipeToClose: true,
      backdropDismiss: true,
      mode: 'ios',
    });
    modal.present();
    let data = (await modal.onDidDismiss()).data;
    console.log(data);
    this.tableStampvalue = data.table;
  }

  signOut() {
    let kiosk = JSON.parse(localStorage.getItem('kiosk'));
    console.log('kioskfromlocal', kiosk);
    if (kiosk != null) {
      this.globals.kiosk_flag = kiosk;
    }

    if (this.globals.kiosk_flag && this.globals.kiosk_flag == true) {
      this.globals.isloggedIn = false;
    } else {
      this.globals.isloggedIn = true;
    }

    this.localStorageService.clearAll();

    this.localStorageService.setTour('Tour', JSON.stringify(true));
    localStorage.setItem('kiosk', JSON.stringify(this.globals.kiosk_flag));

    // console.log('logged out kiosk ', k)
    this.globals.itemsInCart = [];
  }
  async askForTable() {
    const alert = await this.alertCtrl.create({
      message: 'Do you want Dine in or takeout',
      buttons: [
        {
          text: 'Dine in',
          cssClass: 'secondary',
          handler: () => {
            this.enableTable = true;
          },
        },
        {
          text: 'Takeout',
          handler: () => {
            this.enableTable = false;
          },
        },
      ],
    });

    await alert.present();
  }
  saveTable() {
    console.log(this.tableStamp);
    if (this.tableStamp == undefined) {
      this.globals.presentToast('Invalid table token, enter correctly');
    } else {
      this.enableTable = false;
    }
  }
  switchTakeout() {
    this.enableTable = false;
    this.tableStamp = undefined;
  }
  numberPress(value) {
    console.log(value);

    if (value == 'save') {
      console.log('saved');
      this.enableTable = true;
    } else if (value == 'cancel') {
      this.tableStamp = [];
      this.tableStampvalue = '';
      console.log('cancelled');
    } else {
      this.tableStamp.push(value);
      let string = String(this.tableStamp);
      console.log(string);
      //   if(string.includes(',')){
      this.tableStampvalue =
        // string.replace(',','')
        string.replace(/,/gi, '');
      //   }
    }
  }

  captchaResolved(response: string): void {
    this.zone.run(() => {
      this.captchaResponse = response;
    });
  }

}
